import { render, staticRenderFns } from "./AppSwiper.vue?vue&type=template&id=be3509b2"
import script from "./AppSwiper.vue?vue&type=script&lang=js"
export * from "./AppSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports